module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "campusjob-box"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticClass: "d-none d-sm-block banner-pc",
    attrs: {
      "src": require("../../assets/img/campusJob/pc_banner_bg.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "section section-1"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 container-description"
  }, [_c('h2', {
    staticClass: "headline"
  }, [_c('span', [_vm._v("关于甄云")])]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('p', [_vm._v("\n                甄云科技是国内采购数字化管理平台提供商，致力于企业采购管理智能，高效，降本，在全球范围内提供卓越的一站式采购数字化管理平台与采购管理解决方案；\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                甄云已服务500+标杆企业，包括中车，碧桂园集团、新希望集团、光明乳业、潍柴动力、TCL、东方电气、普洛斯、天合光能、石药集团、隆基股份、腾讯旗下公司等国内外知名大中型企业，拥有10万+供应商在线，管理万亿采购交易额。\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                甄云拥有20余项软件著作权，获得政府颁发高新技术企业证书，曾获新华社、中国经济时报、凤凰网、中国财经信息网等多家权威媒体报道。\n              ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("2017年，甄云获得汉得信息天使轮融资")]), _vm._v(" "), _c('p', [_vm._v("2018年，甄云获得京东投资、众麟资本1.5亿元A轮融资")]), _vm._v(" "), _c('p', [_vm._v("\n                2020年，甄云获得蓝湖资本、红点创投、德同资本、钟鼎资本3亿元B轮融资\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                2020年，甄云荣获中国采购数字化厂商榜单前三名，华东CIO最信赖品牌\n              ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section section-2"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 container-description"
  }, [_c('h2', {
    staticClass: "headline"
  }, [_c('span', [_vm._v("加入我们")])]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('p', [_vm._v("\n                我们拥有来自汉得和京东的技术积累、管理经验和合作生态圈，身处SRM领域万亿级别的“蓝海市场”，正处于飞速发展的浪潮之上；\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                我们每天都要接触到各行各业领先的企业和精英，每天都有新的挑战、新的机会、新的责任；\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                我们推崇创业文化，不打卡，福利完善，鼓励学习、鼓励快速发展；\n              ")]), _vm._v(" "), _c('p', [_vm._v("我们的价值观：更好体验、诚信、勤奋、团队、尊重。")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section section-3"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 container-description"
  }, [_c('h2', {
    staticClass: "headline"
  }, [_c('span', [_vm._v("应聘流程")])]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('p', {
    staticClass: "description-apply-process"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/campusJob/recruit-process.png"),
      "title": "应聘流程"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section section-4"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 container-description"
  }, [_c('h2', {
    staticClass: "headline"
  }, [_c('span', [_vm._v("简历投递方式")])]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('p', [_vm._v("请在邮件标题注明：“姓名-学校-应聘职位“")]), _vm._v(" "), _c('p', [_vm._v("\n                简历请用附件形式发送至\n                "), _c('a', {
    attrs: {
      "href": "mailto:Xiaoyi.li02@hand-china.com"
    }
  }, [_vm._v("Xiaoyi.li02@hand-china.com")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section section-5"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 container-description"
  }, [_c('h2', {
    staticClass: "headline"
  }, [_c('span', [_vm._v("2021管理培训生和实习生招聘职位")])]), _vm._v(" "), _c('div', {
    staticClass: "recruit-jobs"
  }, [_c('div', {
    staticClass: "item",
    attrs: {
      "id": "jobs-item"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h5', [_c('a', {
    staticClass: "iconfont",
    attrs: {
      "href": "javascript:;",
      "role": "button"
    }
  }, [_vm._v("技术开发工程师（Java后端开发工程师）")])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h3', [_vm._v("职位描述：")]), _vm._v(" "), _c('p', [_vm._v("\n                        根据业务需求完成应用系统后端设计及开发实现，包括设计应用系统相关数据结构，代码逻辑结构，业务逻辑功能开发实现及相关开发文档的撰写和维护。\n                      ")]), _vm._v(" "), _c('h3', [_vm._v("职位要求：")]), _vm._v(" "), _c('p', [_vm._v("\n                        熟悉Java 或其他面向对象编程语言，具有 Java\n                        实际项目开发经验者优先考虑；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("\n                        熟悉常用代码开发框架，有 Spring、Spring MVC、Spring\n                        Boot、MyBatis 等框架使用经验者优先；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("\n                        了解微服务架构设计理念，熟悉微服务常用架构及相关组件,对分布式、缓存、消息等机制熟悉者优先；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("\n                        熟悉 MySQL、Oracle 等数据库，掌握 SQL\n                        语句的编写者优先；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("\n                        具备优秀的自我学习和独立思考能力，乐于钻研技术，对新技术领域有良好洞察力和关注度；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("\n                        具有良好的团队协作精神，富有工作激情、创新欲望和责任感。\n                      ")]), _vm._v(" "), _c('h3', [_vm._v("专业要求：")]), _vm._v(" "), _c('p', [_vm._v("\n                        计算机、软件工程、信息管理与信息系统等计算机相关专业；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("\n                        有计算机相关课程的其他专业（在计算机软件编程相关方面有较强能力者不限制专业）。\n                      ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h5', [_c('a', {
    staticClass: "iconfont",
    attrs: {
      "href": "javascript:;",
      "role": "button"
    }
  }, [_vm._v("技术开发工程师（Web前端开发工程师）")])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h3', [_vm._v("职位描述：")]), _vm._v(" "), _c('p', [_vm._v("\n                        根据业务需求，完成应用系统前端页面设计和实现，包括设计应用系统相关数据结构，代码逻辑结构，业务逻辑功能开发实现及相关开发文档的撰写和维护。\n                      ")]), _vm._v(" "), _c('h3', [_vm._v("职位要求：")]), _vm._v(" "), _c('p', [_vm._v("\n                        熟练使用JavaScript、CSS/CSS3、HTML/HTML5编程开发，了解其标准规范及各浏览器差异性；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("\n                        掌握至少一种主流JS框架，如Angular\n                        JS/Angular、Vue.js、React等；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("熟练使用前端代码管理及打包工具；")]), _vm._v(" "), _c('p', [_vm._v("\n                        具备优秀的自我学习和独立思考能力，乐于钻研技术，对新技术领域有良好洞察力和关注度；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("\n                        具有良好的团队协作精神，富有工作激情、创新欲望和责任感。\n                      ")]), _vm._v(" "), _c('h3', [_vm._v("专业要求：")]), _vm._v(" "), _c('p', [_vm._v("\n                        计算机、软件工程、信息管理与信息系统等计算机相关专业；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("\n                        有计算机相关课程的其他专业（在计算机软件编程相关方面有较强能力者不限制专业）；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("\n                        有过“非课程要求”的PS、美工、UI设计等相关专业优先。\n                      ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h5', [_c('a', {
    staticClass: "iconfont",
    attrs: {
      "href": "javascript:;",
      "role": "button"
    }
  }, [_vm._v("产品经理")])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h3', [_vm._v("职位描述：")]), _vm._v(" "), _c('p', [_vm._v("\n                        洞察市场需求，结合项目提出的需求进行梳理分析、形成解决方案及产品设计；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("\n                        与技术沟通评估实现方案，跟踪开发、测试及上线流程，确保产品功能的落地与交付；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("\n                        协助运营团队以及交付团队，推动产品上线与推广应用和后续迭代完善。\n                      ")]), _vm._v(" "), _c('h3', [_vm._v("职位要求：")]), _vm._v(" "), _c('p', [_vm._v("\n                        责任心强，具有服务意识和自觉担当意识，优秀的表达沟通能力，组织协调能力及团队合作精神；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("\n                        具备良好的逻辑思维能力、较强的学习能力和自我驱动力；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("具有良好的英语听说读写能力。")]), _vm._v(" "), _c('h3', [_vm._v("专业要求：")]), _vm._v(" "), _c('p', [_vm._v("计算机、软件工程等专业")]), _vm._v(" "), _c('p', [_vm._v("\n                        管理科学、管理工程、信息管理与信息系统、电子商务等专业；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("物理、数学或相近的理科专业；")]), _vm._v(" "), _c('p', [_vm._v("工业工程、机械设计、自动化或相近的工科专业；")]), _vm._v(" "), _c('p', [_vm._v("\n                        会计、财务管理、国际贸易、物流、人力资源管理等专业；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("欢迎其他专业优秀人才应聘。")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h5', [_c('a', {
    staticClass: "iconfont",
    attrs: {
      "href": "javascript:;",
      "role": "button"
    }
  }, [_vm._v("业务实施顾问")])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h3', [_vm._v("职位描述：")]), _vm._v(" "), _c('p', [_vm._v("\n                        满足企业对于信息化建设的需求，基于信息化管理软件的应用，为企业设计合理的供应链业务流程和系统应用方案。通过规划、调研、分析、设计、实现、培训、运维等手段，实现企业的采购数字化转型；\n                      ")]), _vm._v(" "), _c('h3', [_vm._v("职位要求：")]), _vm._v(" "), _c('p', [_vm._v("211,985等国内一流大学本科学历，研究生优先")]), _vm._v(" "), _c('p', [_vm._v("\n                        责任心强，具有服务意识和自觉担当意识，优秀的表达沟通能力，组织协调能力及团队合作精神；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("\n                        具备良好的逻辑思维能力、较强的学习能力和自我驱动力；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("具有良好的英语（或日语）听说读写能力。")]), _vm._v(" "), _c('h3', [_vm._v("专业要求：")]), _vm._v(" "), _c('p', [_vm._v("\n                        管理科学、管理工程、信息管理与信息系统、电子商务等专业；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("物理、数学或相近的理科专业；")]), _vm._v(" "), _c('p', [_vm._v("工业工程、机械设计、自动化或相近的工科专业；")]), _vm._v(" "), _c('p', [_vm._v("\n                        会计、财务管理、国际贸易、物流、人力资源管理等专业；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("欢迎其他专业优秀人才应聘。")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h5', [_c('a', {
    staticClass: "iconfont",
    attrs: {
      "href": "javascript:;",
      "role": "button"
    }
  }, [_vm._v("客户经理")])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h3', [_vm._v("职位描述：")]), _vm._v(" "), _c('p', [_vm._v("快速学习并熟悉SAAS与咨询行业销售模式，快速成长。")]), _vm._v(" "), _c('p', [_vm._v("\n                        负责整合公司资源，分析、把握、引导客户需求，进行潜在客户的商机挖掘与开发；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("\n                        负责销售招投标及商务相关文档的准备、管理、归类、整理和保管工作；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("负责维护与拓展客户资源渠道；")]), _vm._v(" "), _c('p', [_vm._v("\n                        负责收集客户反馈和竞争动手动态，制定销售策略，对项目进行有效推动负责公司能力对外销售，从商机开发跟进到成交整个过程，负责客户的深度挖掘和经营。\n                      ")]), _vm._v(" "), _c('h3', [_vm._v("职位要求：")]), _vm._v(" "), _c('p', [_vm._v("\n                        成就动力：个人成就感至上，有明确的自主意识，渴望成功，愿意面对挑战，获得更快速成长\n                      ")]), _vm._v(" "), _c('p', [_vm._v("\n                        逻辑能力：思维缜密，逻辑清晰，善于分析问题和解决问题\n                      ")]), _vm._v(" "), _c('p', [_vm._v("\n                        沟通能力：谈吐得体，善于倾听，表达优秀，文案能力出色\n                      ")]), _vm._v(" "), _c('p', [_vm._v("\n                        学习能力：能够快速学习销售领域与各相关行业的专业知识，吐故纳新，举一反三\n                      ")]), _vm._v(" "), _c('h3', [_vm._v("专业要求：")]), _vm._v(" "), _c('p', [_vm._v("专业不限制")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h5', [_c('a', {
    staticClass: "iconfont",
    attrs: {
      "href": "javascript:;",
      "role": "button"
    }
  }, [_vm._v("市场销售经理")])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h3', [_vm._v("职位描述：")]), _vm._v(" "), _c('p', [_vm._v("\n                        通过各种渠道挖掘客户需求，使用规范的、标准的语言开展电话营销工作，开发新客户；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("\n                        通过电话与主动咨询的客户进行有效沟通了解客户需求，做好记录和客户分析；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("\n                        对销售线索进行跟进，跟踪销售跟进状态，做好相关记录并分析；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("\n                        针对历史遗留的客户进行阶段性回访，挖掘潜在新客户；\n                      ")]), _vm._v(" "), _c('h3', [_vm._v("职位要求：")]), _vm._v(" "), _c('p', [_vm._v("热爱工作，善于表达和归纳，有良好的团队合作精神；")]), _vm._v(" "), _c('p', [_vm._v("具备良好的沟通能力；")]), _vm._v(" "), _c('p', [_vm._v("为人正直，性格开朗，胆大心细，勇于创新；")]), _vm._v(" "), _c('p', [_vm._v("具备较强的学习能力和自我驱动力；")]), _vm._v(" "), _c('p', [_vm._v("有大型集团企业市场、销售实习经验者优先。")]), _vm._v(" "), _c('h3', [_vm._v("专业要求：")]), _vm._v(" "), _c('p', [_vm._v("\n                        市场营销、管理科学、人力资源管理、企业管理、心理学等专业优先。\n                      ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h5', [_c('a', {
    staticClass: "iconfont",
    attrs: {
      "href": "javascript:;",
      "role": "button"
    }
  }, [_vm._v("新媒体运营大V")])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h3', [_vm._v("职位描述：")]), _vm._v(" "), _c('p', [_vm._v("\n                        负责微信、抖音、视频号、头条、百家号、新浪号等自媒体平台的排版，编辑、日常内容更新及素材收集；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("\n                        结合行业热点、热门话题，针对性的做活动或内容的策划、互动，执行以及效果跟踪；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("\n                        执行相关线上的运营推广活动，通过有效运营手段提升用户活跃度及关注度；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("针对项目进行内容维护和相关数据统计并分析总结；")]), _vm._v(" "), _c('h3', [_vm._v("职位要求：")]), _vm._v(" "), _c('p', [_vm._v("\n                        熟练操作主流排版软件或平台，了解熟悉相关素材资源获取方式；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("\n                        具备良好的文案能力及优秀的沟通能力和团队合作精神；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("为人正直，性格开朗，胆大心细，勇于创新；")]), _vm._v(" "), _c('p', [_vm._v("具备较强的学习能力和自我驱动力；")]), _vm._v(" "), _c('p', [_vm._v("有大型集团企业市场、新媒体、报社实习经验者优先；")]), _vm._v(" "), _c('h3', [_vm._v("专业要求：")]), _vm._v(" "), _c('p', [_vm._v("\n                        汉语言文学、新闻学、传播学、市场营销、管理科学等专业优先。\n                      ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h5', [_c('a', {
    staticClass: "iconfont",
    attrs: {
      "href": "javascript:;",
      "role": "button"
    }
  }, [_vm._v("运维顾问")])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h3', [_vm._v("职位描述：")]), _vm._v(" "), _c('p', [_vm._v("远程解决客户提交的问题并给出解决方案；")]), _vm._v(" "), _c('p', [_vm._v("指导和协助新顾问处理问题；")]), _vm._v(" "), _c('p', [_vm._v("\n                        定期主动的学习新知识、新模块，拓展自己的专业知识面，并在团队中分享；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("必要的客户现场项目支持")]), _vm._v(" "), _c('h3', [_vm._v("职位要求：")]), _vm._v(" "), _c('p', [_vm._v("\n                        有较强服务意识，有优秀的表达沟通能力，组织协调能力及团队合作精神；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("\n                        有强烈的责任心和敬业精神，乐于在挑战性强、节奏快的环境下工作；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("愿意在上海长期稳定；")]), _vm._v(" "), _c('p', [_vm._v("拥有良好的英语（或日语）听说读写能力者优先；")]), _vm._v(" "), _c('h3', [_vm._v("专业要求：")]), _vm._v(" "), _c('p', [_vm._v("\n                        管理科学、管理工程、信息管理与信息系统、电子商务等专业；\n                      ")]), _vm._v(" "), _c('p', [_vm._v("英语、日语等语言专业；")]), _vm._v(" "), _c('p', [_vm._v("欢迎其他专业优秀人才应聘。")])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0be5878"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aboutUs/campusJob.vue
// module id = 624
// module chunks = 12